/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const interviewBookingTokenResponseMeetingLocationType = {
	jobilla_meet: 'jobilla_meet',
	google_meet: 'google_meet',
	teams: 'teams',
	zoom: 'zoom',
	phone: 'phone',
	in_person: 'in_person',
	custom: 'custom',
} as const

export type InterviewBookingTokenResponseMeetingLocationType =
	(typeof interviewBookingTokenResponseMeetingLocationType)[
		keyof typeof interviewBookingTokenResponseMeetingLocationType
	]
